import type {ReactElement} from 'react';
import {hexToRgb, PMW_COLORS_NEUTRAL, rgbToHexString} from '@Utils/color.util';
import {Circle} from '@Components/circular-progress/components/circle/circle';
import {cleanPercentage} from '@Components/circular-progress/components/circle/circle.helper';

interface CircularProgressProps {
  className?: string;
  value: number;
  /** Hex colour of the filled arc; the track behind it is the same colour, faded. Defaults to white, for the dark surfaces this started on. */
  color?: string;
}

export function CircularProgress({className = '', color = PMW_COLORS_NEUTRAL.NEUTRAL_0, ...props}: CircularProgressProps): ReactElement {
  const STROKE_WIDTH = 3;
  const CIRCLE_DIAMETER = 16;

  return (
    <svg className={className} width={CIRCLE_DIAMETER} height={CIRCLE_DIAMETER}>
      <g transform={`rotate(-90 ${CIRCLE_DIAMETER / 2} ${CIRCLE_DIAMETER / 2})`}>
        <Circle percentage={cleanPercentage(100)} strokeWidth={STROKE_WIDTH} circleDiameter={CIRCLE_DIAMETER} color={rgbToHexString(hexToRgb(color), 0.4)} />
        <Circle percentage={cleanPercentage(props.value)} strokeWidth={STROKE_WIDTH} circleDiameter={CIRCLE_DIAMETER} color={color} />
      </g>
    </svg>
  );
}
